export default __webpack_public_path__ + "static/media/linkedin.71a7c544.svg";